import { render, staticRenderFns } from "./HGB.vue?vue&type=template&id=27130e5a&scoped=true&"
import script from "./HGB.vue?vue&type=script&lang=js&"
export * from "./HGB.vue?vue&type=script&lang=js&"
import style0 from "./HGB.vue?vue&type=style&index=0&id=27130e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27130e5a",
  null
  
)

export default component.exports